import type { Investment } from '@/hooks/useInvestments';

export function useInvestmentTeamLock(investment: Investment | undefined) {
  if (!investment) return false;
  const startTime = Number(investment.investmentStartTime);
  const endTime = Number(investment.investmentEndTime);
  const startDate = new Date(startTime * 1000);
  const endDate = new Date(endTime * 1000);
  const diff = endDate.getTime() - startDate.getTime();
  const diffMonths = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));

  return diffMonths > 33;
}